import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => {
  return <Spinner animation="border" variant="info" />;
};

export default Loader;
